import styled from 'styled-components';

const Screen = styled.div`
  width: 100%;
  height: 100%;
`;

export default Screen;
